import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HtmlMapper = _resolveComponent("HtmlMapper")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HtmlMapper, {
      restricted: $props.restricted,
      nodes: $options.nodes
    }, null, 8 /* PROPS */, ["restricted", "nodes"])
  ]))
}